import { Button, Input } from '@servicetim/ui/components';
import { X } from 'lucide-react';

export interface ColorInputProps {
  id?: string;
  value: string | null | undefined;
  onChange: (next: string | null) => void;
  disabled?: boolean;
  invalid?: boolean;
}

const HEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

/** Native color picker + hex text field + clear; the value is `#rgb` / `#rrggbb` or `null`. */
export function ColorInput({ id, value, onChange, disabled, invalid }: ColorInputProps) {
  const hex = value ?? '';
  return (
    <div className="flex items-center gap-2">
      <input
        type="color"
        aria-label="Pick a color"
        value={HEX.test(hex) && hex.length === 7 ? hex : '#94a3b8'}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="size-9 cursor-pointer rounded-md border border-border-strong bg-surface-raised p-0.5"
      />
      <Input
        id={id}
        value={hex}
        onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
        placeholder="#1d4ed8"
        disabled={disabled}
        aria-invalid={invalid || (hex !== '' && !HEX.test(hex)) || undefined}
        className="w-32 font-mono"
        maxLength={7}
      />
      {hex !== '' && !disabled ? (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-8"
          aria-label="Clear color"
          onClick={() => onChange(null)}
        >
          <X />
        </Button>
      ) : null}
    </div>
  );
}
